export default __webpack_public_path__ + "static/media/5627eaecad1a26a71ec5a268c10c7a23.svg";